import { render, staticRenderFns } from "./ledger-list.vue?vue&type=template&id=54af77a0&scoped=true&"
import script from "./ledger-list.vue?vue&type=script&lang=js&"
export * from "./ledger-list.vue?vue&type=script&lang=js&"
import style0 from "./ledger-list.vue?vue&type=style&index=0&id=54af77a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54af77a0",
  null
  
)

export default component.exports